import MuiMenuItem from '@mui/material/MenuItem';

import { styled } from 'helpers';

export const MenuItem = styled(MuiMenuItem)`
  &.Mui-selected,
  &.Mui-selected:hover,
  &.Mui-focusVisible,
  &:focus,
  &:hover {
    background-color: ${({ theme }) => theme.palette.grey['A50']};
  }
` as typeof MuiMenuItem;
